import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OciParModel } from '../models/storage';
import { EnvironmentService } from './environment.service';


@Injectable({
  providedIn: 'root'
})
export class StorageOracleService {

  ociObjs: OciParModel[] = [];
  preAuthenticatedRequestString: string;

  constructor(private http: HttpClient, private env: EnvironmentService, private route: ActivatedRoute) {
  }

  /// helper functions
  findBucketObj(bucket: string): OciParModel{
    return this.ociObjs.find(obj => obj.bucketName == bucket);
  }

  checkIfParTokenExpired(bucket: string): boolean{
    let bucketObj: OciParModel = this.ociObjs.find(obj => obj.nameSpace == bucket);
    if(bucketObj){
      const date = new Date();
      if(new Date(bucketObj.expiry) > date){
        return false;
      }
      this.ociObjs = this.ociObjs.filter(obj => obj.bucketName != bucket);
    }
    return true
  }

  arrangeDirPath(path: string): string{
    path = path.replace(this.env.envVariables.syncStoreRoute,"").replace(this.env.envVariables.workStoreRoute, "");
    if(path.substring(0,1) == "/") path = path.substring(1);
    path = path?.split("/")?.map(p => p?.split("@")[0])?.join("/");
    return path;
  }

  /// api's
  async getPreAuthenticatedUri(depName: string, bucket: string){
    return new Promise((resolve, reject) => {
      let isExpired = this.checkIfParTokenExpired(bucket);
      if(!isExpired) { resolve("Already present");return; }
      let url = this.env.envVariables.httpProtocol + this.env.envVariables.webHost + `StorageInfoes/Deployment/${depName}/GetPreAuthenticatedUri/namespace/${bucket}`;
      return this.http.get(url).subscribe({
        next: (data: OciParModel) => {
          this.ociObjs.push(data);
          resolve(true);
        },
        error: (err) => {
          resolve(false);
        }
      });
    })
  }

  getStorageData(depName: string, bucket: string, path: string){
    let namespaceObj = this.findBucketObj(bucket);
    path = this.arrangeDirPath(path);
    let url = this.env.envVariables.httpProtocol + this.env.envVariables.webHost + `StorageInfoes/Deployment/${depName}/GetAllObjectOracle/bucket/${namespaceObj.bucketName}/namespace/${namespaceObj.nameSpace}`;
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('Cache-Control', 'no-cache').set('Path', path == "" ? path : path + "/")
    return this.http.get(url, {headers: headers});
  }

  viewFileData(bucket: string, objectName: string){
    let namespaceObj = this.findBucketObj(bucket);
    objectName = this.arrangeDirPath(objectName);
    let url = `https://objectstorage.${namespaceObj.endpoint}/p/${namespaceObj.parToken}/n/${namespaceObj.nameSpace}/b/${namespaceObj.bucketName}/o/${objectName}`;
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('Cache-Control', 'no-cache')
    return this.http.get(url, { headers, responseType: 'text' });
  }

  uploadObject(objectLoc: string, file: File, bucket: string){
    let namespaceObj = this.findBucketObj(bucket);
    objectLoc = this.arrangeDirPath(objectLoc);
    let url = `https://objectstorage.${namespaceObj.endpoint}/p/${namespaceObj.parToken}/n/${namespaceObj.nameSpace}/b/${namespaceObj.bucketName}/o/${objectLoc}`;
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/octet-stream')
      .set('Cache-Control', 'no-cache');
    return this.http.put(url, file, {
      headers,
      reportProgress: true,
      observe: 'events'
    });
  }

  createFolder(folderName:string, bucket: string){
    let namespaceObj = this.findBucketObj(bucket);
    folderName = this.arrangeDirPath(folderName);
    let url = `https://objectstorage.${namespaceObj.endpoint}/p/${namespaceObj.parToken}/n/${namespaceObj.nameSpace}/b/${namespaceObj.bucketName}/o/${folderName}/`;
    return this.http.put(url, "");
  }

  deleteObject(depName: string, bucket: string, objectName: string){
    let namespaceObj = this.findBucketObj(bucket);
    objectName = this.arrangeDirPath(objectName);
    let url = this.env.envVariables.httpProtocol + this.env.envVariables.webHost + `StorageInfoes/Deployment/${depName}/DeleteStorageObject/bucket/${namespaceObj.bucketName}/namespace/${namespaceObj.nameSpace}`;
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/octet-stream')
      .set('Cache-Control', 'no-cache')
      .set('ObjectName', objectName)
    return this.http.delete(url, {headers: headers});
  }

  downloadFile(bucket: string, objectName: string){
    let namespaceObj = this.findBucketObj(bucket);
    objectName = this.arrangeDirPath(objectName);
    let url = `https://objectstorage.${namespaceObj.endpoint}/p/${namespaceObj.parToken}/n/${namespaceObj.nameSpace}/b/${namespaceObj.bucketName}/o/${objectName}`;
    return url;
  }

  async verifyDirectoryPath(storageName: string, paths: string[]): Promise<boolean> {
    for (const path of paths) {
      try {
        await this.createFolder(path, storageName).toPromise();
      } catch (error) {
        console.log(`Directory might already exist: ${path}`);
      }
    }
    return true;
  }
}
